import React from 'react';
import { Link } from 'react-router-dom';

import FlagIcon from '@atlaskit/icon/glyph/flag-filled';
import PageHeader from '@atlaskit/page-header';
import {
  Box,
  xcss
} from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useAccountsMapping } from 'src/services/accountsMapping';

import jira from 'src/lib/api/jira';
import { getEnvironment, getProdEnvironment } from 'src/lib/featureFlags';

import LoginMessage from './components/LoginMessage';
import ConfigWithAccountsMapping from './ConfigWithAccountsMapping';
import ConfigWithoutAccountsMapping from './ConfigWithoutAccountsMapping';

const NewAdminPage = () => {
  const [accountsMapping] = useAccountsMapping();
  if (accountsMapping) return <ConfigWithAccountsMapping/>;
  return <ConfigWithoutAccountsMapping/>;
};

const containerStyles = xcss({
  maxWidth: '1200px',
});

const AdminTopLevel = () => {
  const showFF = jira.isFeatureFlagsEnabled();
  return (
    <Box xcss={containerStyles}>
      <PageHeader>
        PagerDuty settings
      </PageHeader>

      {getEnvironment().integrationServiceBaseUrl !== getProdEnvironment().integrationServiceBaseUrl
      && <span style={{ color: token('color.text.danger', 'red'), fontSize: token('font.size.075', '12px') }}>
        Using non-prod integration service: {getEnvironment().integrationServiceBaseUrl}
      </span>}
      <div style={{ marginTop: 20 }}>
        <NewAdminPage/>
      </div>
      <div style={{ margin: '60px auto 0 auto' }}>
        <LoginMessage/>
      </div>
      {showFF && (
        <div style={{ float: 'right' }}>
          <Link to="/integration-jira-ui/feature_flags"><FlagIcon size="small" label="Feature flags"/></Link>
        </div>
      )}
    </Box>
  );
};

export default AdminTopLevel;
